const EquipmentSlots = Object.freeze([
	'HEAD',
	'NECK',
	'SHOULDER',
	'BACK',
	'CHEST',
	'SHIRT',
	'WRIST',
	'HANDS',
	'WAIST',
	'LEGS',
	'FEET',
	'TABARD',
	'FINGER_1',
	'FINGER_2',
	'TRINKET_1',
	'TRINKET_2',
	'MAIN_HAND',
	'OFF_HAND'
]);

export default EquipmentSlots;
